import { AnyAction } from 'redux';
import { EBoxDashboardData } from '../../types';

import { carsActions } from '../reducer';

export const updateCarEBoxDashboardData = (
  eBoxDashboardData?: EBoxDashboardData[]
): AnyAction => carsActions.updateEBoxDashboardData(eBoxDashboardData);
